<template>
  <div id="sdk1">
    <Menu></Menu>
    <div class="contact">
      <div class="contact-title">
        <div class="title">感谢联系ToDesk企业版</div>
        <div class="detail">请留下您想咨询的问题，客户经理将尽快与您联系</div>
      </div>
      <div class="contact-form">
        <el-form
          ref="refForm"
          :model="form_data"
          :rules="rules"
          label-width="134px"
          label-position="top"
          size="normal"
        >
          <el-form-item label="公司名称" prop="corp_name">
            <el-input v-model="form_data.corp_name" maxlength="64" />
          </el-form-item>
          <el-form-item label="怎么称呼您" prop="user_name">
            <el-input v-model="form_data.user_name" maxlength="64" />
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model.number="form_data.mobile" />
          </el-form-item>
          <el-form-item label="您的职业" prop="position">
            <el-radio
              v-for="(item, index) in roleList"
              :key="index"
              v-model="form_data.position"
              :label="item.value"
              border
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item label="使用人数" prop="population_size">
            <el-radio
              v-for="(item, index) in userNumList"
              :key="index"
              v-model="form_data.population_size"
              :label="item.value"
              border
              >{{ item.label }}</el-radio
            >
          </el-form-item>
          <el-form-item
            label="我有其他问题/建议/需求"
            prop="_woyouqitawentijianyi"
          >
            <div class="textarea">
              <el-input
                type="textarea"
                v-model="form_data._woyouqitawentijianyi"
                maxlength="500"
              />
              <span class="number"
                >{{ form_data._woyouqitawentijianyi.length || 0 }} / 500</span
              >
            </div>
          </el-form-item>
          <el-button
            class="btn"
            type="primary"
            :loading="loading"
            @click="onSubmit"
            >提交</el-button
          >
        </el-form>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import axios from 'axios';
export default {
  name: "RegisterPage",
  components: {
    Menu,
    Footer,
  },
  data() {
    const validatorCheckMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入电话"));
      } else if (value.length === 11) {
        callback(new Error("请输入正确格式的手机号"));
      } else if (!/^(?:(?:\+|00)86)?[1|9][3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确格式的手机号"));
      } else {
        callback();
      }
    };
    const validatorCheckUser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (value.length > 0) {
        const number = value
          .split("")
          .map((v) => (/[\u0391-\uFFE5]/.test(v) ? 2 : 1))
          .reduce((p, c, i) => {
            const len = p + c;
            return len;
          }, 0);
        if (number > 64) {
          callback(
            new Error(
              "请输入正确格式的名称，最大长度不超过32位汉字，不支持输入表情符号"
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      form_data: {
        mobile: "",
        // email: "",
        corp_name: "",
        user_name: "",
        position: "",
        population_size: "",
        _woyouqitawentijianyi: "",
      },
      rules: {
        mobile: [
          {
            required: true,
            validator: validatorCheckMobile,
            trigger: "change",
          },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "change" }],
        corp_name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "change",
          },
        ],
        user_name: [
          {
            required: true,
            validator: validatorCheckUser,
            trigger: "change",
          },
        ],
        position: [
          {
            required: true,
            message: "请选择职位",
            trigger: "change",
          },
        ],
      },
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      roleList: [
        {
          label: "部门主管",
          value: "部门主管", // 1
        },
        {
          label: "企业高管",
          value: "企业高管", // 2
        },
        {
          label: "IT负责人",
          value: "IT负责人", // 3
        },
        {
          label: "个人试用",
          value: "个人试用", // 4
        },
      ],
      userNumList: [
        {
          label: "10人以下",
          value: "10人以下", // 5
        },
        {
          label: "10-49人",
          value: "10-49人", // 2
        },
        {
          label: "50-99人",
          value: "50-99人", // 1
        },
        {
          label: "100-499人",
          value: "100-499人", // 4
        },
        {
          label: "500人以上",
          value: "500人以上", // 3
        },
      ],
      loading: false,
    };
  },
  methods: {
    onSubmit() {
      if (!this.loading) {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.loading = true;
            await axios.post(`/api/config/addCompany`, {
              user_name: this.form_data.user_name,
              corp_name: this.form_data.corp_name,
              mobile: this.form_data.mobile,
              position: this.form_data.position,
              population_size: this.form_data.population_size,
              _woyouqitawentijianyi: this.form_data._woyouqitawentijianyi,
              source: 74201532, // 来源 配合C端限制引导转化企业版
            });
            this.$router.push({ path: "/trial" });
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.contact {
  width: 100%;
  margin: 0 auto 50px;
  .contact-title {
    background: url("../assets/contact/bg.png") no-repeat center;
    background-size: cover;
    padding: 29px 24px;
    .title {
      font-size: 18px;
      line-height: 25px;
      color: #000000;
      margin-bottom: 7px;
    }
    .detail {
      width: 256px;
      font-size: 14px;
      line-height: 20px;
      color: #747576;
    }
  }
}
.contact-form {
  padding: 20px 24px 0;
  ::v-deep .el-form-item {
    margin-bottom: 22px;
  }
  ::v-deep .el-form-item__label {
    line-height: 16px;
  }
  .el-radio.is-bordered {
    position: relative;
    &:nth-child(3) {
      margin-right: 0px;
    }
    width: 100px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    text-align: center;
    border: 1px solid #c4c8cc;
    background: #fff;
    margin-right: 12px;
    border-radius: 6px;
    margin-left: 0 !important;
    margin-bottom: 14px;
    box-sizing: border-box;
    ::v-deep .el-radio__label {
      font-size: 14px;
      color: #444546;
      padding-left: 0;
      // position: relative;
      // top: -1px;
    }
    ::v-deep .el-radio__input {
      display: none;
    }
    &.is-checked,
    &:hover {
      background: #eff7ff;
      border: 1px solid #0059c8;
      ::v-deep .el-radio__label {
        color: #0059c8;
      }
    }
  }

  .btn {
    width: 100%;
    background: #216ed8;
    &:hover {
      background-color: #0b80fe;
    }
  }
  ::v-deep .el-textarea__inner {
    min-height: 80px !important;
  }
  .textarea {
    position: relative;
    .number {
      position: absolute;
      right: 10px;
      bottom: 10px;
      font-size: 12px;
      color: #999;
      line-height: 16px;
    }
  }
}
.qrcodeimg {
  width: 50%;
  margin: 0px auto;
}
</style>
